import { createSlice } from "@reduxjs/toolkit";
const initialState = {};
const slice = createSlice({
    initialState,
    name: "WidgetsWithoutDataReducers",
    reducers: {
        setWidgetNoData: (state, action) => {
            state[action.payload.widgetId] = action.payload.value;
        }
    }
});
export const widgetsWithoutDataReducers = slice.reducer;
export const { setWidgetNoData } = slice.actions;
